import { render, staticRenderFns } from "./block-accordions.vue?vue&type=template&id=4080b3f4&scoped=true&"
import script from "./block-accordions.vue?vue&type=script&lang=js&"
export * from "./block-accordions.vue?vue&type=script&lang=js&"
import style0 from "./block-accordions.vue?vue&type=style&index=0&id=4080b3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080b3f4",
  null
  
)

export default component.exports